var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_vm._m(0),_c('p',[_vm._v("Page Not Found")]),_c('router-link',{staticClass:"button is-light redirect-button",attrs:{"to":_vm.homeRoute}},[_vm._v(" Take Me Home ")]),_c('hr')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-code"},[_c('h1',[_vm._v("Error 404")])])
}]

export { render, staticRenderFns }